export enum ScheduleType {
  INCLUDE = 'INCLUDE',
  EXCLUDE = 'EXCLUDE'
}

export const ScheduleTypeTranslation = {
  [ScheduleType.INCLUDE]: 'Obejmujący',
  [ScheduleType.EXCLUDE]: 'Wykluczający'
};
